import { Box, CircularProgress } from "@mui/material";
import type { JSX } from "react";

/**
 * The full-viewport loading state `RequireAuth` shows while `AuthProvider`
 * is still asking the BFF who the visitor is. Extracted so the auth-aware
 * home route (`HomeRoute`) can share the same markup: it renders this while
 * the session is loading, so a reload on a live session never flashes the
 * public landing page before redirecting to the portal.
 */
export function FullPageSpinner(): JSX.Element {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        bgcolor: "background.default",
      }}
    >
      <CircularProgress size={28} sx={{ color: "accent.500" }} aria-label="Loading" />
    </Box>
  );
}
